/*
  Authored by Brett Barinaga on 11/17/21.
  Copyright (c) Kochava, Inc. All rights reserved.
*/
import { getBaseDomain } from "./browser";
export var setCookie = function (name, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + 3650 * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toUTCString());
    document.cookie =
        name +
            "=" +
            (value || "") +
            expires +
            "; path=/;domain=" +
            getBaseDomain();
};
export var getCookie = function (name) {
    var nameEQ = name + "=";
    var charArray = document.cookie.split(';');
    for (var i = 0; i < charArray.length; i++) {
        var char = charArray[i];
        while (char.charAt(0) === " ")
            char = char.substring(1, char.length);
        if (char.indexOf(nameEQ) === 0)
            return char.substring(nameEQ.length, char.length);
    }
    return "";
};
export var deleteCookie = function (name) {
    if (getCookie(name)) {
        var path = "/";
        var domain = getBaseDomain();
        document.cookie = name + "=" +
            ((path) ? ";path=" + path : "") +
            ((domain) ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
};
